import { Dialog } from '@headlessui/react'
import { useAddonContext } from '../context/AddonFeatureContext'
import { filledstars, notFilledstars } from '../pages/NewPostPaymentFeature/CourseDetailsModal'
import { useDispatch, useSelector } from 'react-redux'
import { selectShowCategoryModal, setShowCategoryModal } from '../redux/otherDetailsSlice'
import { selectAddOns, setProMembershipSelected } from '../redux/addOnSlice'
import ProMembershipSection from '../pages/AddOnPage/ProMembershipSection'
import CloseModal from './CloseModal'
import { BottomPriceSection } from '../pages/AnalysisPage/NewCourseDetailsModal'
import { selectPriceChart } from '../redux/priceChartSlice'

export const SkillsListToShow = ({ skills, ratings, students, doNotshowRating }) => {
    
    return <div className='flex flex-col gap-1.5'>
        {skills.map((item, index) => (
            <div key={index} className='bg-bg-2 flex items-center rounded-xl py-2.5 px-3'>
                <h3 className='flex-1 text-sm font-medium'>{item?.skill_name}</h3>
                {!doNotshowRating && <div className='flex flex-col gap-0.5 items-center mt-1'>
                    <div className='flex'>
                        {filledstars(ratings[index])}
                        {notFilledstars(ratings[index])}
                    </div>
                    <p className='text-xs text-white/50 mt-0.5'>{students[index]} Students</p>
                </div>}
            </div>
        ))}
    </div>
}

const CategoryModal = () => {

    const showCategoryModal = useSelector(selectShowCategoryModal)
    const addOns = useSelector(selectAddOns)
    const priceChart = useSelector(selectPriceChart)

    const { proMembershipSelected } = addOns

    const { setShowSkillList } = useAddonContext()

    const dispatch = useDispatch()

    const handleModal = () => {
        setShowSkillList(false)
        dispatch(setShowCategoryModal(false))
    }
    
    return (
        <div>
            <Dialog
                open={showCategoryModal}
                onClose={handleModal}
                as='div'
                className="fixed z-40 inset-0 flex flex-col mx-auto text-white"
            >
                <Dialog.Overlay className="fixed inset-0 mx-auto z-50 bg-black opacity-80" />
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='p-[1px] bg-glass-effect m-auto max-w-2xl rounded-2xl w-[90%] z-[80] shadow-[0_0_20px_rgba(0, 0, 0, 0.3)]'>
                    <div className={`bg-custom-bg relative rounded-2xl max-h-[550px] overflow-y-scroll`}>
                        <div className='p-3 rounded-2xl'>
                            <div className='flex items-center justify-between'>
                                <h1 className='text-xl font-bold'>Unlimited Access To 1240+ Courses</h1>
                                <CloseModal handleModal={handleModal} />
                            </div>
                            <div className='mt-6'>
                                <ProMembershipSection />
                            </div>
                        </div>
                        <BottomPriceSection
                            selected={proMembershipSelected}
                            setSelect={setProMembershipSelected}
                            discountedPrice={priceChart[65]?.price}
                            originalPrice={priceChart[65]?.original_price}
                            showFree={false}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default CategoryModal